{
  "api": {
    "eu": "https://eu.api.tmplvision.io/v1",
    "us": "https://us.api.tmplvision.io/v1"
  }
}
